import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

export interface TeachingAreasLinksProps {
  children: ReactNode;
  className?: string;
}

export const TeachingAreasLinks = ({ children, className }: TeachingAreasLinksProps) => {
  return (
    <div
      className={twMerge('relative flex w-full basis-1/3 flex-col text-white md:flex-row md:justify-evenly', className)}
    >
      <h2
        className="font-proxima before:contents-[''] mb-8 pb-[10px] text-[18px] leading-[1.25] before:absolute before:top-[calc(18px_*_1.25_+_10px)]
          before:h-1 before:w-10 before:rounded-full before:bg-lime md:w-1/3 font-semibold"
      >
        Teaching areas
      </h2>
      <ul className="block w-full basis-2/3 columns-1 flex-col space-y-2.5 md:space-y-6 md:font-bold md:columns-2 leading-[21px]">{children}</ul>
    </div>
  );
};
